import { render, staticRenderFns } from "./InteractionAverageWidget.vue?vue&type=template&id=2018cea8"
import script from "./InteractionAverageWidget.vue?vue&type=script&lang=ts"
export * from "./InteractionAverageWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports